import script from "./WorkspaceUpdatePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceUpdatePanel.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceUpdatePanel.vue?vue&type=style&index=0&id=08aa14c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08aa14c4"]])

export default __exports__